import { UserStorageService } from './shared/services/storage/user-storage.service';
import { AfterViewInit, Component, ComponentRef, DestroyRef, HostListener, Inject, NgZone, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Platform, PopoverController, ToastController, MenuController, IonModal, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { UserBasicInfo, UserBasicService } from './shared/services/user-basic.service';
import { TranslateService } from '@ngx-translate/core';
import { ChangeLanguageService } from './shared/services/change-language.service';
import { AuthenticationService } from './shared/services/authentication.service';
import { RegisterService } from './shared/services/register.service';
import { ThemeService } from './shared/services/theme.service';
import { PushyService } from './shared/services/pushy.service';
import { HelpersService } from './shared/services/helpers.service';
import { NotificationsStorageService } from './shared/services/storage/notifications-storage.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageURL } from './pages/pages';
import { distinctUntilChanged, filter, finalize } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DataService } from './shared/services/send-data.service';
import { Location } from '@angular/common';
import { AppCacheStorageService } from './shared/services/storage/app-cache-storage.service';
import { AppConfig, APP_CONFIG } from './shared/services/config-initialization.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DynamicPath } from './shared/services/dynamic-path.service';
import { ConsoleToggleService } from './shared/services/console-toggle.service';
import { GTMService } from './shared/services/GoogleTagManager/googleTagManager.service';
import { EnvironmentService, TagManagerServiceProvider } from './shared/services/GoogleTagManager/googleTagManager.service.provider';
import { ThemeControllerService } from './shared/services/theme-controller.service';
import { RefreshmentTimeService } from './pages/refreshment-time/refreshment-time.service';
import { LoyaltyService } from './pages/loyalty/loyalty.service';
import { loadPushySdk } from './shared/services/lazy-runtime-loaders';
import { RegistrationNavigationLoaderService } from './shared/services/registration-navigation-loader.service';
import { SessionTimeoutService } from './shared/services/session-timeout.service';

export const apiURLs = {
  getInitialData: '/content/login/initial'
};

const maskConfigResponse = [
  
];

const maskConfigRequest = [
  {
    match: (url: string) => url?.includes('auth') || url?.includes('live/new') || url?.includes('demo/new'),
    fields: ['password','confirmOrgToken']
  },
  {
    match: (url: string) => url?.includes('pswd/setPost'),
    fields: ['newPassword']
  },
  {
    match: (url: string) => url?.includes('password/change'),
    fields: ['currentPassword', 'newPassword']
  }
];

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    animations: [
        trigger('toggleMenu', [
            state('true', style({ width: '260px' })),
            state('false', style({ width: '70px' })),
            transition('false <=> true', animate(100))
        ])
    ],
    providers: [
        EnvironmentService,
        TagManagerServiceProvider
    ],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly Math = Math;
  registrationNavigationLoading = false;
  public selectedIndex = 0;
  public selectedIndexSub;
  public selectedIndexFooter;
  private fullStoryClient: any;
  public appPages = [
    {
      id: 0,
      htmlId: 'account',
      title: 'bottomNavigation_accounts',
      bottomTitle: 'Accounts',
      url: '/accounts',
      open: false,
      // icon: 'home'
      icon_active: 'wb-accounts-active.svg',
      icon_inactive: 'wb-accounts-inactive.svg',
      icon_inactive_dark: 'wb-accounts-inactive-dark.svg'
    },
    {
      id: 1,
      htmlId: 'payments',
      title: 'bottomNavigation_payments',
      url: '/payments',
      bottomTitle: 'Payments',
      open: false,
      // icon: 'wallet'
      icon_active: 'wb-payments-active.svg',
      icon_inactive: 'wb-payments-inactive.svg',
      icon_inactive_dark: 'wb-payments-inactive-dark.svg'

    },
    {
      id: 2,
      htmlId: 'markets',
      title: 'bottomNavigation_markets',
      bottomTitle: 'Markets',
      // icon: 'globe',
      open: false,
      icon_active: 'wb-markets-active.svg',
      icon_inactive: 'wb-markets-inactive.svg',
      icon_inactive_dark: 'wb-markets-inactive-dark.svg',
      children: [
        {
          id: 2.1,
          htmlId: 'instruments',
          title: 'menu_InstrumenetsAnalysis',
          bottomTitle: 'Instruments & Analysis',
          open: false,
          url: '/instruments',
          icon_active: 'wb-instruments-active.svg',
          icon_inactive: 'wb-instruments-inactive.svg',
          icon_inactive_dark: 'wb-instruments-inactive-dark.svg',
        },
        {
          id: 2.2,
          htmlId: 'newsSentiments',
          title: 'menu_NewsSentiments',
          bottomTitle: 'Sentiments',
          open: false,
          url: '/news',
          icon_active: 'wb-news-active.svg',
          icon_inactive: 'wb-news-inactive.svg',
          icon_inactive_dark: 'wb-news-inactive-dark.svg',
        },
        {
          id: 2.3,
          htmlId: 'economicCalendar',
          title: 'menu_EconomicCalendar',
          bottomTitle: 'Economic Calendar',
          open: false,
          url: '/calendar',
          icon_active: 'wb-calendar-active.svg',
          icon_inactive: 'wb-calendar-inactive.svg',
          icon_inactive_dark: 'wb-calendar-inactive-dark.svg',
        },
        {
          id: 2.4,
          htmlId: 'pricingAnalytics',
          title: 'menu_PricingAnalytics',
          bottomTitle: 'Pricing Analytics',
          open: false,
          url: '/pricing',
          icon_active: 'wb-pricing-active.svg',
          icon_inactive: 'wb-pricing-inactive.svg',
          icon_inactive_dark: 'wb-pricing-inactive-dark.svg',
        },
        {
          id: 2.5,
          htmlId: 'tradingIdes',
          title: 'menu_TradingIdeas',
          bottomTitle: 'Trading Ideas',
          open: false,
          url: '/ideas',
          icon_active: 'wb-ideas-active.svg',
          icon_inactive: 'wb-ideas-inactive.svg',
          icon_inactive_dark: 'wb-ideas-inactive-dark.svg',
        },
      ]
    },
    {
      id: 3,
      htmlId: 'tools',
      title: 'bottomNavigation_tools',
      bottomTitle: 'Tools',
      open: false,
      // icon: 'globe',
      icon_active: 'wb-tools-active.svg',
      icon_inactive: 'wb-tools-inactive.svg',
      icon_inactive_dark: 'wb-tools-inactive-dark.svg',
      children: [
        {
          id: 3.1,
          htmlId: 'webinars',
          title: 'menu_Webinars',
          bottomTitle: 'Webinars',
          open: false,
          url: '/webinars',
          icon_active: 'wb-webinars-active.svg',
          icon_inactive: 'wb-webinars-inactive.svg',
          icon_inactive_dark: 'wb-webinars-inactive-dark.svg',
        },
        {
          id: 3.2,
          htmlId: 'education',
          title: 'menu_Education',
          bottomTitle: 'Education',
          open: false,
          url: '/education',
          icon_active: 'wb-education-active.svg',
          icon_inactive: 'wb-education-inactive.svg',
          icon_inactive_dark: 'wb-education-inactive-dark.svg',
        },
        {
          id: 3.3,
          htmlId: 'calculator',
          title: 'menu_Calculator',
          bottomTitle: 'Calculator',
          open: false,
          url: '/calculator',
          icon_active: 'wb-calculator-active.svg',
          icon_inactive: 'wb-calculator-inactive.svg',
          icon_inactive_dark: 'wb-calculator-inactive-dark.svg',
        }
      ]
    },
    {
      // View more page must be ID 5 or changed also in method openPopup()
      id: 5,
      htmlId: 'viewMore',
      title: 'bottomNavigation_more',
      bottomTitle: 'More',
      url: '/view-more',
      open: false,
      // icon: 'ellipsis-horizontal-circle',
      icon_active: 'wb-viewmore-active.svg',
      icon_inactive: 'wb-viewmore-inactive.svg',
      icon_inactive_dark: 'wb-viewmore-inactive-dark.svg'
    }
  ];
  public appBottomPages = [
    //for client's with out bi portal
    
  ];
  
  

  userLoggedIn: boolean;
  authSub: Subscription;
  themeSub: Subscription;
  selectedTheme: string;
  userInfo: UserBasicInfo;
  userBasicSub: Subscription;
  pagesChecked: boolean;
  langSub: Subscription;
  language: string;
  availableLangsSub: Subscription;
  availableLanguages: any[];
  langDirection: string = 'ltr';
  sharedSwitchLang: any;
  sharedLogout: any;
  sharedOpenTools: any;
  deviceLanguage: any;
  showActions: boolean = false;
  nextAction: any;
  verifyEmailMenuDisable: boolean = false;
  foundNextAction: boolean = false;
  menuArrow: string;
  menuOpen: boolean = true;
  showPop: boolean = false;
  splitUrl: any;
  mobileMenu: boolean = false;
  submenuOpen: boolean = false;
  activePage: any;
  openBottomModal: boolean = false;
  mobileVersion: boolean = false;
  selectedSubMenu: any;
  activeUrl: string;
  showMenu: boolean= false;
  PageURL: typeof PageURL = PageURL;
  @ViewChild('modalBottom') bottomModal: IonModal;
  @ViewChild('salesforceChatHost', { read: ViewContainerRef }) salesforceChatHost?: ViewContainerRef;
  activeParent: number = 0;
  currentLang: string;
  languageCodes: any = ['en','ar','fa','fr','pl','es','ja','zh','ko','id','th','ms','vi'];
  maintenanceModeOn: boolean = false;
  hasFullStoryInitialized: boolean = false;
  toast: HTMLIonToastElement;

  fontSizes: any = {en:14,ar:14,fa:14,fr:14,pl:14,es:13,ja:11,zh:14,ko:14,id:14,th:13,ms:14,vi:10,pt:14};
  fontSize: any = 14;
  isLoggedIn: boolean = false;
  redirectUrlDetails: string = '';
  menuLogoSrc: string = '';
  private notificationListenerInitialized = false;
  private salesforceChatComponentRef?: ComponentRef<any>;
  private salesforceChatComponentLoaded = false;

  constructor(
    private menuCtrl: MenuController,
    private platform: Platform,
    private router: Router,
    private dataSource: DataService,
    public readonly translate: TranslateService,
    private readonly changeLangService: ChangeLanguageService,
    public readonly toastController: ToastController,
    public readonly popoverController: PopoverController,
    public readonly modalController: ModalController,
    private readonly auth: AuthenticationService,
    private readonly userBasicService: UserBasicService,
    private readonly organizationService: RegisterService,
    private readonly theme: ThemeService,
    private readonly pushy: PushyService,
    private readonly helpers: HelpersService,
    private readonly notificationService: NotificationsStorageService,
    private ngZone: NgZone,
    private location: Location,
    private readonly userStorage: UserStorageService,
    private readonly cache: AppCacheStorageService,
    private route: ActivatedRoute,
    private readonly dynamicPath: DynamicPath,
    @Inject(APP_CONFIG) private config: AppConfig,
    private consoleToggleService: ConsoleToggleService,
    private readonly googleTagManagerService: GTMService,
    private readonly http: HttpClient,
    private readonly loyaltySrv: LoyaltyService,
    private readonly regService: RegisterService,
    private readonly themeControllerService: ThemeControllerService,
    private readonly refreshmentTimeService: RefreshmentTimeService,
    private readonly registrationNavigationLoader: RegistrationNavigationLoaderService,
    readonly sessionTimeout: SessionTimeoutService,
    private readonly destroyRef: DestroyRef,
  ) {
    this.registrationNavigationLoader.active$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(active => this.registrationNavigationLoading = active);
    this.themeControllerService.getThemeBasedOnDomain(this.config.cid,this.config.bucketUrl);
    this.consoleToggleService.disableConsoleInProduction();
    this.menuLogoSrc = this.resolveMenuLogo();
    this.initializeApp();
    //load tag manager only on production and uat
    
  }

  async initTagManager() {
    if(this.config.production || this.config.uat) {
      if ((window as any).__wbGtmInitialized) {
        return;
      }
      (window as any).__wbGtmInitialized = true;
      //const {TagManagerModule} = await import("./shared/modules/googleTagModule.module")
      // let module = new NgModule()
      // module.imports.push(TagManagerModule)
      this.loadScript();
    }
  }

  getInitialContent(): Observable<any> {
    return this.http.get(this.config.restApiUrl + apiURLs.getInitialData);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.getInitialContent().subscribe(data => {
        // console.log("INITIAL DATA: ", data);
        this.regService.setOrganizationCombinations(data.organizationsCombinations);
  
        this.theme.testDevicePreference(false);
        this.pushNotificationListeners();
      });
    });
  }

  loadScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='" + this.config.googleManagerPath + "?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','"+this.config.googleManagerId+"')";
    const head = document.getElementsByTagName('head')[0];
    if (head !== null && head !== undefined) {
      document.head.appendChild(script);
    }
  }
  
  checkSafari() {
    this.platform.ready().then(() => {
    const ua = navigator.userAgent;

    const isSafari =
      /Safari/i.test(ua) &&
      !/CriOS|FxiOS|EdgiOS|OPiOS|Chrome|Chromium|Android/i.test(ua);

    if (isSafari) {
      document.documentElement.classList.add('safari');
    }
  });
}

  ngOnInit() {
    this.sessionTimeout.warningVisible$
      .pipe(
        distinctUntilChanged(),
        filter(visible => visible),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        void this.closeActivePopupsForSessionTimeout();
      });

    this.auth.checkStorage().then(authenticated => {
      if (authenticated) this.sessionTimeout.start();
    });
    this.checkSafari();
    this.googleTagManagerService.initGtmDom();

    this.langInit();
    this.initTagManager();
    this.scheduleNonCriticalStartupWork(() => {
      this.fullStoryInit();
    });

    // Keep query-param handling lightweight to avoid recreating language subscriptions.
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(params => {
        if (params['lang']) {
          this.language = params['lang'];
          if (this.availableLanguages?.length > 0) {
            this.setLanguage(this.language);
          }
        }
        if (params['returnUrl']) {
          this.dynamicPath.setPath(params['returnUrl'] + (params['lang'] ? '?lang=' + params['lang'] : ''));
        }
      });

    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(e => {
        this.updateShellForUrl(e.url);
        if (this.userLoggedIn || this.isLoggedIn) {
          this.loadCacheWithRetry()
            .then((data) => {
              this.googleTagManagerService.feedier(data, e.url, this.currentLang);
            })
            .catch(() => {
              // Feedier data is optional; keep navigation responsive if cache is empty.
            });
        }
      });

    this.authSub = this.auth.authenticationState
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe(res => { 
      this.userLoggedIn = res;
      //console.log('res in APP component:', res);
      if (res) {
        setTimeout(()=>{
          // this.theme.getSavedTheme();
          this.userBasicService.getBasicInfo().subscribe();
          this.getUserInfo();
          this.setLanguage(this.language);
          this.refreshmentTimeService.getKycStatus().subscribe();
        }, 0);
      } else {
        this.isLoggedIn = false;
        this.clearSalesforceChatComponent();
        this.changeLangService.setAllLanguages();
      }
    });

    this.themeSub = this.theme.getActiveTheme()
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe(val => {
      this.selectedTheme = val;
      this.menuLogoSrc = this.resolveMenuLogo();
    });

    this.dataSource.data
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((responseData) => {
      //console.log('response' , responseData);
      this.showPop = responseData;
    });

  }

  private scheduleNonCriticalStartupWork(task: () => void): void {
    const idleWindow = window as Window & {
      requestIdleCallback?: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number;
    };

    if (idleWindow.requestIdleCallback) {
      idleWindow.requestIdleCallback(() => task(), { timeout: 2000 });
      return;
    }

    setTimeout(task, 0);
  }
  
  fullStoryInit() {
    if (this.config.fsf === 'true') {
      this.ensureFullStoryLoaded().then((fullStory) => {
        if (!fullStory?.init) {
          return;
        }

        fullStory.init({
          orgId: this.config.fsid,
          host: 'eu1.fullstory.com',
          appHost: 'app.eu1.fullstory.com'
        });
      });
    }
  }


  private ensureFullStoryLoaded(): Promise<any> {
    if (!this.fullStoryClient) {
      this.fullStoryClient = import('@fullstory/browser').then((module: any) => ({
        FullStory: module.FullStory ?? module.default ?? module,
        init: module.init ?? module.default?.init
      }));
    }

    return this.fullStoryClient;
  }
  
  loadCacheWithRetry(retries = 2) {
    return new Promise((resolve, reject) => {
      this.cache.load('feedier').then((data) => {
        if (data !== null && typeof data !== 'undefined') {
          resolve(data);
        } else if (retries > 0) {
          console.log(`Data is null, retrying... (${retries} attempts left)`);
          setTimeout(() => {
            this.loadCacheWithRetry(retries - 1).then(resolve).catch(reject);
          }, 1000); // Retry after a 1-second delay
        } else {
          reject(new Error('Data is null after retrying'));
        }
      }).catch(reject);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(this.showMenu){
      //if simulator/device is changed, it must be refreshed to update the platfroms
      //e,g, open iphone on chrome dev tools, platfors are set for iphone
      //if you switch to ipad in dev tools the platforms remain those of the iphone until you refresh
      //This scenario should be unrealistic in real life
      if(event.target.innerWidth < 768 || (this.platform.platforms().includes('mobile') && !this.platform.platforms().includes('tablet') && event.target.innerWidth < 916)){
        this.mobileMenu = true;
      } else {
        if( event.target.innerWidth <= 1460){
          this.menuOpen = false;
        } else {
          this.menuOpen = true;
        }
        this.mobileMenu = false;
      }
    }
  }

  closerModal(){
    this.showPop = false;
  }

  private async closeActivePopupsForSessionTimeout(): Promise<void> {
    this.showPop = false;
    for (let attempts = 0; attempts < 10; attempts++) {
      const overlay = await this.modalController.getTop();
      if (!overlay || overlay.classList.contains('session-timeout-modal')) break;
      await overlay.dismiss(undefined, 'session-timeout');
    }

    for (let attempts = 0; attempts < 10; attempts++) {
      const overlay = await this.popoverController.getTop();
      if (!overlay) break;
      await overlay.dismiss(undefined, 'session-timeout');
    }
  }

  ngAfterViewInit() { 
    this.updateMenuState(this.location.path());
    void this.loadSalesforceChatComponent();
  }

  controlPages(parentID,item=null,childID=null) {
    if (item == 'parent') {
      this.submenuOpen = false;
      this.appPages[parentID].open = !this.appPages[parentID].open;
      if (this.appPages[parentID].open) { // parent page just opened
        this.appPages.forEach(page => {
          if (page.id != parentID) {
            page.open = false;
          }
        });
      }
      else { // parent just closed
        this.appPages[parentID].open = false;
        this.appPages[parentID].children.forEach(child => {
          child.open = false;
        });
      }
    }
    else if (item == 'child') {
      this.activeParent = parentID;
      this.appPages.forEach(page => {
        if (page.id != parentID) {
          page.open = false;
          if (page.children) {
            page.children.forEach(child => {
              child.open = false;
            });
          }
        }
        else {
          page.open = true;
          page.children.forEach(child => {
            if (child.id == childID) child.open = true;
            else child.open = false;
          });
        }
      });
    }
    else {
      this.submenuOpen = false;
      this.activeParent = parentID;
      this.appPages.forEach(page => {
        if (page.id != parentID) {
          page.open = false;
          if (page.children) {
            page.children.forEach(child => {
              child.open = false;
            });
          }
        }
        else page.open = true;
      });
    }
  }

  ngOnDestroy() {
    this.authSub.unsubscribe();
    this.themeSub.unsubscribe();
    // this.pushSub.unsubscribe();
    this.userBasicSub.unsubscribe();
    // this.disconnectSubscription.unsubscribe();
    // this.connectSubscription.unsubscribe();
  }

  trackByPage(index: number, page: any): string | number {
    return page?.url ?? page?.htmlId ?? index;
  }

  trackByChild(index: number, child: any): string | number {
    return child?.url ?? child?.htmlId ?? index;
  }

  private updateShellForUrl(url: string): void {
    this.activeUrl = url;

    if (url?.includes('/verifyemail/') || url?.includes('/welcome') || url?.includes('/register') || url?.includes('/maintenance') || url?.includes('/recovertoken/token') || url?.includes('/forgot-password') || url?.includes('/version') || url?.includes('/pswdset') || url?.includes('/epaymentsmobile') || url?.includes('/refreshment')) {
      this.menuCtrl.enable(false);
      this.mobileMenu = false;
      this.showMenu = false;
    } else {
      this.menuCtrl.enable(true);
      this.showMenu = true;
      //if simulator/device is changed, it must be refreshed to update the platfroms
      //e,g, open iphone on chrome dev tools, platfors are set for iphone
      //if you switch to ipad in dev tools the platforms remain those of the iphone until you refresh
      //This scenario should be unrealistic in real life
      if (window.innerWidth < 768 || (this.platform.platforms().includes('mobile') && !this.platform.platforms().includes('tablet') && window.innerWidth < 916)) {
        this.mobileMenu = true;
      }
      if (window.innerWidth <= 1460) {
        this.menuOpen = false;
      }
    }

    this.updateMenuState(url);
  }

  private updateMenuState(url: string): void {
    this.appPages.forEach(page => {
      page.open = false;
      if (!page.children) {
        if (page.url == url) {
          page.open = true;
          this.activeParent = page.id;
        }
      } else {
        page.children.forEach(child => {
          if (child.url == url) {
            page.open = true;
            child.open = true;
            this.activeParent = page.id;
          } else {
            child.open = false;
          }
        });
      }
    });
  }

  private resolveMenuLogo(): string {
    const cid = this.config.cid;

    switch (cid) {
      case 'MWP105':
      case 'MUH864':
      case 'CUH689':
        return this.selectedTheme == 'dark'
          ? `${this.config.bucketUrl}/assets/images/wb-white-logo-02.svg`
          : `${this.config.bucketUrl}/assets/images/wb-dark-logo.svg`;
      case 'WBI483':
        return this.selectedTheme == 'dark'
          ? `${this.config.bucketUrl}/assets/images/wbi-menu-whitelogo-01.svg`
          : `${this.config.bucketUrl}/assets/images/wbi-menu-darklogo.svg`;
      case 'MWM230':
        return this.selectedTheme == 'dark'
          ? `${this.config.bucketUrl}/assets/images/wm-dark.svg`
          : `${this.config.bucketUrl}/assets/images/wm.svg`;
      default:
        return `${this.config.bucketUrl}/assets/images/logo-placeholder-image.png`;
    }
  }

  openPopup(page){
    this.userInfo.actions.forEach(action => {
      console.log(page)
      if (action.id == "VerifyEmail" && !(page.id == 5)) {
        this.router.navigate(['/accounts']);
        if(page?.url == '/accounts') return;
        this.emailVerifyPopover(this.translate.instant(action.text), this.userInfo.Email);
      }
    });
  }

  async emailVerifyPopover(text:string, userEmail:any) {
    const { EmailVerifyPopoverComponent } = await import('./shared/components/notifications/email-verify-popover/email-verify-popover.component');
    const popover = await this.popoverController.create({
      component: EmailVerifyPopoverComponent,
      componentProps: {
        text: text,
        userEmail: userEmail
      },
      cssClass: 'email-verify-popover'
    });
    return await popover.present();
  }

  navigateToPage(url: string) {
    this.router.navigate([url]);
  }

  setLogo() {
    let cid = this.config.cid;
    let imgHubLink = this.config.userHubLink;
    switch(cid){
      case 'MWP105':
        if (this.selectedTheme == 'light') {
          return `${this.config.bucketUrl}/assets/images/wb-dark-logo.svg`;
        } 
        if (this.selectedTheme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/wb-white-logo-02.svg`;
        }
        break;
      case 'MUH864':
      case 'CUH689':
        if (this.selectedTheme == 'light') {
          return `${this.config.bucketUrl}/assets/images/wb-dark-logo.svg`;
        } 
        if (this.selectedTheme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/wb-white-logo-02.svg`;
        }
        break;
      case 'WBI483':
        if (this.selectedTheme == 'light') {
          return `${this.config.bucketUrl}/assets/images/wbi-menu-darklogo.svg`;
        } 
        if (this.selectedTheme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/wbi-menu-whitelogo-01.svg`;
        }
        break;
      case 'MWM230':
        if (this.selectedTheme == 'light') {
          return `${this.config.bucketUrl}/assets/images/wm.svg`;
        } 
        if (this.selectedTheme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/wm-dark.svg`;
        }
        break;
      default:
        if (this.selectedTheme == 'light') {
          return `${this.config.bucketUrl}/assets/images/logo-placeholder-image.png`;
        } 
        if (this.selectedTheme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/logo-placeholder-image.png`;
        }
        break;      
    }
  }

  getDeviceLanguage(){
    let devLang = navigator.language.toLowerCase();
    this.language = 'en';
    this.languageCodes.forEach(lang => {
      if (devLang?.includes(lang)) {
        //console.log("supported: "+devLang);
        if (lang == 'ms') lang = 'my';
        this.language = lang;
      }
    });
    this.setLanguage(this.language);
    this.changeLangService.setLang(this.language);
  }

  langInit() {
    this.translate.setDefaultLang('en');
    this.availableLangsSub = this.changeLangService.getAvailableLangs().subscribe(langList => {
      this.availableLanguages = langList;
      //console.log('LANG LIST', langList);
      this.setLanguage(this.language);
    });

    this.changeLangService.isLanguageLoaded().subscribe( loaded => {
      if(loaded){
        this.langSub = this.changeLangService.getCurrentLang().subscribe(lang => {     
          if (lang) {
            this.currentLang = lang;
            //console.log(`retrieved language from storage: ${lang}`);
            //alert(`retrieved language from storage: ${lang}`)
            this.setLanguage(lang);
            for (const [key, value] of Object.entries(this.fontSizes)) {
              if (key == lang) {
                this.fontSize = value + 'px';
                break;
              }
            }
          } else { // no lang in storage, so it's the first use of the app
            //console.log(`NO language from storage.`);
            this.getDeviceLanguage();       
          }
        });
      }
    })
  }

  setLanguage(lang: string, deviceLang?: any): void {
    if (lang && this.availableLanguages.length > 0) {
      let langAllowed;
      this.availableLanguages.forEach(language => {
        if (lang === language.code) {  
          langAllowed = true;       
        }
      });

      if (langAllowed) {
        //console.log('LANGUAGE IS ALLOWED');
        this.language = lang;  

       this.translate.use(this.language)
          .pipe(
            finalize(() => {
              window.portalTranslationsReady?.();
              console.log('[Portal] Language activation finalized.');
            })
          )
          .subscribe({
            next: () => {
              console.log('[Portal] Language ready:', this.language);
              window.portalTranslationsReady?.();
            },
            error: error => {
              console.error('[Portal] Failed to activate language:', error);
            }
          });
        console.log('[Portal] portalReady called setLanguage');
        //this.changeLangService.setLang(this.language);
        //console.log('app component: language is changed to: ' + this.language);
        if (deviceLang) this.changeLangService.setLang(this.language);

        if (lang == 'ar' || lang == 'fa') {
          this.langDirection = 'rtl';
          this.menuArrow = 'chevron-forward-outline';
        } else {
          this.langDirection = 'ltr';
          this.menuArrow = 'chevron-back-outline';
        }    
      } else {
        //console.log('LANGUAGE IS NOT ALLOWED');
        let msg = 'The selected language is not supported by this organisation. Language is set to English.';
        this.presentToastLang(this.translate.instant(msg));
        this.language = 'en';
        this.changeLangService.setLang(this.language);
      }
    }  
  }

  getUserInfo(): void {
    this.userBasicSub = this.userBasicService.basicInfo().subscribe(
      (info: UserBasicInfo) => { 
        if (info) {
          this.userInfo = info;
          this.isLoggedIn = true;
          void this.loadSalesforceChatComponent();
          if(this.userInfo?.feedier != null){
            this.cache.save('feedier', this.userInfo?.feedier);  
          }
          if(this.config.fsf === 'true' && !this.hasFullStoryInitialized) {
            this.ensureFullStoryLoaded().then((fullStory) => {
              if (fullStory?.FullStory) {
                fullStory.FullStory('setIdentity', {
                  uid: this.userInfo.Id.toString(),
                  properties:{
                    displayName: this.userInfo.Id.toString()
                  }
                });
                this.hasFullStoryInitialized = true;
                console.log('FullStory identify with uid:', this.userInfo.Id);
              }
            });
          }
          
          console.log('userInfo app component',this.userInfo);
          
          /* Restric user from accessing copy trading by changing the url */
          if((window.location.host?.includes('jo') || (window.location.host?.includes('sc') && (this.userInfo.CountryCode == 'JO' || this.userInfo.CountryCode == 'PS')) || window.location.host?.includes('ps') || window.location.host?.includes('cy') || window.location.host?.includes('eu')) && window.location.pathname == PageURL.COPYTRADING) {
            this.router.navigate([PageURL.ACCOUNTS]);
          }
          for (let action of this.userInfo.web_actions) {
            if (action.finished == false) {
              this.nextAction = action;
              this.foundNextAction = true;
              break;
            }
          }
          
          /* filter side-menu pages based on deniedPages from user info */
          this.appPages = this.appPages
            .map(page => {
              if (page.children) {
                page.children = page.children.filter(child => !this.userInfo?.deniedPages.includes(child.url));
              }
              return page;
            }).filter(page => !this.userInfo?.deniedPages.includes(page.url) && (page.children ? page.children.length > 0 || !page.children : true));

          
          /* add or remove copy trading side-menu option */
          if(this.userInfo.copytrading && !((window.location.host?.includes('jo') || (window.location.host?.includes('sc') && (this.userInfo.CountryCode == 'JO' || this.userInfo.CountryCode == 'PS')) || window.location.host?.includes('ps') || window.location.host?.includes('cy') || window.location.host?.includes('eu')))){
            if(this.appPages[4]?.url != '/copy-trading'){
              this.appPages.splice(4,0,
                {
                  id: 4,
                  htmlId: 'copyTrading',
                  title: 'pageTitle_CopyTrading',
                  url: '/copy-trading',
                  open: false,
                  bottomTitle: 'Copy Trading',
                  // icon: 'ellipsis-horizontal-circle',
                  icon_active: 'wb-copytrading-active.svg',
                  icon_inactive: 'wb-copytrading-inactive.svg',
                  icon_inactive_dark: 'wb-copytrading-inactive-dark.svg'
                }
              )
            }
          } else {
            const existingMenuItemIndex = this.appPages.findIndex(item => item.url === '/copy-trading');
            if (existingMenuItemIndex !== -1) {
              this.appPages.splice(existingMenuItemIndex, 1);
            }
          }
                    
          this.getOrganizationData();
          /* loyaltyDowngrade notification */
          if (!this.notificationListenerInitialized) {
            this.notificationListenerInitialized = true;
            this.notificationService.notifications.subscribe( notifications => {
              for(let notification of notifications){
                if(notification.category == 'accounts' && !notification.toast && notification.path == '/toast/warning' && !notification.seen){
                  this.presentToastWarning(notification.message);
                  notification.toast = true;
                  this.notificationService.save(this.userInfo.Id, notification.id, notification).subscribe();
                }
                if(notification.category == 'accounts'  && !notification.popup && notification.path == '/show/voucherUpgrade' && !notification.seen){
                  this.getLoyaltyRewardsById('loyaltyVoucherStatus');
                  notification.popup = true;
                  this.notificationService.save(this.userInfo.Id, notification.id, notification).subscribe();
                }
                if(notification.category == 'accounts'  && !notification.popup && notification.path == '/show/depositBonus' && !notification.seen){
                  this.getLoyaltyRewardsById('depositBonus');
                  notification.popup = true;
                  this.notificationService.save(this.userInfo.Id, notification.id, notification).subscribe();
                }
              }
            });
          }
          this.notificationService.getAllFromRedis(this.userInfo.Id).subscribe();
          this.pushy.subscribeToPushy(info.SFAccountID);
        }
      }
    );
  }

  private async loadSalesforceChatComponent(): Promise<void> {
    if (!this.userInfo || !this.isLoggedIn || this.salesforceChatComponentLoaded) {
      if (this.salesforceChatComponentRef) {
        this.salesforceChatComponentRef.setInput('userInfo', this.userInfo);
      }
      return;
    }

    const host = this.salesforceChatHost;
    if (!host) {
      return;
    }

    const { SalesforceChatComponent } = await import('./shared/components/salesforce-chat/salesforce-chat.component');
    host.clear();
    this.salesforceChatComponentRef = host.createComponent(SalesforceChatComponent);
    this.salesforceChatComponentRef.setInput('userInfo', this.userInfo);
    this.salesforceChatComponentLoaded = true;
  }

  private clearSalesforceChatComponent(): void {
    this.salesforceChatComponentRef?.destroy();
    this.salesforceChatComponentRef = undefined;
    this.salesforceChatComponentLoaded = false;
    this.salesforceChatHost?.clear();
  }
  
  getLoyaltyRewardsById(id: string){
    this.loyaltySrv.GetLoyaltyRewardsById(id).subscribe((res) => {
        console.log(res);
        this.presentLoyaltyVoucherUpgradePopup(res?.upgradeInfo,id);
      },
      (error: HttpErrorResponse) => {
        if(error.error.error === 'Your are not eligible for this promotion') {
          this.router.navigate([PageURL.ACCOUNTS]);
        } 
        if (error.error.error.includes('Missing parameters')) {
          this.router.navigate([PageURL.LOYALTY]);
        }
      }
      
    );
  }
  
  async presentLoyaltyVoucherUpgradePopup(info: any,id: string) {
    const { LoyaltyWbGoldUpgradeComponent } = await import('./shared/components/loyalty-wb-gold-upgrade/loyalty-wb-gold-upgrade.component');
    const modal = await this.modalController.create({
        component: LoyaltyWbGoldUpgradeComponent,
        componentProps: {
          info: info,
          id: id
        },
        cssClass: 'wb-gold-modal',
        backdropDismiss: true
      });
      modal.onDidDismiss().then(returnData => {
        if (returnData.data) {
            
        }
      });
    return await modal.present();
  }

  getOrganizationData(): void {
    this.organizationService.getAvailableCountries().subscribe(
      (res) => {
        //console.log('ORG DATA:', res);
        let organization = this.userInfo.OrganizationLowerCase;

        res.body.forEach(org => {
          if (org.name === organization) {
            this.changeLangService.setAvailableLangs(org.languages);
          }
        });
      }
    )
  }

  pushNotificationListeners() {
      void loadPushySdk().then((Pushy) => {
        // Listen for push notifications
        Pushy.setNotificationListener((data) => {
        // Print notification payload data
        //console.log('Received notification test: ' + JSON.stringify(data));
        //alert('Received notification: ' + JSON.stringify(data))
        let time = new Date().getTime();
        let id = data.id || this.helpers.generateRandomString(16); 
        let message = data.message; // string
        let category = data.category.toLowerCase(); // string
        let title = data.title || '';
        let path = data.path;
        // save notification in local storage
        // save notification in db
        const notification = {
          path,
          time,
          id,
          message,
          category,
          title,
          seen: false
        }
        this.ngZone.run(() => {
          // Bring event back inside Angular's zone
          if (category) {
            //alert('saving notification: ' + JSON.stringify(notification));
            let info = this.userBasicService.basicInfoValue();

            if (info) {
              this.notificationService.save(info.Id, id, notification).subscribe();
              this.userInfo = info;
            } else {
              this.userBasicService.getBasicInfo().subscribe(
                (res) => {
                  this.userInfo = res.body;
                  let accountId = res.body.Id;
                  this.notificationService.save(accountId, id, notification).subscribe();
                });
            }
          }
        });
        // Display an alert with the "message" payload value
        //alert('Received notification: ' + data.message);

        });
      });
  }

  async presentToastWarning(message) {
    this.toast = await this.toastController.create({
      message,
      animated: true,
      position: 'top',
      color: "warning",
      cssClass: 'toast-warning-card',
      buttons: [
        {
          side: 'start',
          icon: 'notifications',
        },
        {
          text: this.translate.instant('x'),
          role: 'cancel',
        }
      ],
      duration: 10000
    });
    this.toast.present();
  }

  async presentToastLang(message: string): Promise<any> {
    const toast = await this.toastController.create({
      message,
      duration: 10000,
      buttons: [
        {
          text: this.translate.instant('Close'),
          role: 'cancel',
        }
      ]
    });
    toast.present();
  }

  switchTheme(theme: string) {
    this.theme.setActiveTheme(theme);
  }

  switchLang(lang: string): void {
    this.changeLangService.setLang(lang);
  }

  logout(): void {
    this.auth.logout();
    this.clearSalesforceChatComponent();
  }

  openActions() {
    this.showActions = !this.showActions;
  }

  toggleMenu(shouldOpen?:boolean) {
    if (shouldOpen) this.menuOpen = true;
    else this.menuOpen = !this.menuOpen;
    if(this.menuOpen) {
      if(this.langDirection === 'ltr'){
        this.menuArrow = 'chevron-back-outline'
      } else {
        this.menuArrow = 'chevron-forward-outline'
      }
      
    } else {
      if(this.langDirection === 'ltr'){
        this.menuArrow = 'chevron-forward-outline'
      } else {
        this.menuArrow = 'chevron-back-outline'
      }
      
    }
  }
  
  redirect(url){
    window.location.href = url + this.redirectUrlDetails;
  }

  onPageClicked(page) {

    if(page === null) {
      this.submenuOpen = false;
      this.appPages.map( p => {
        if(p.open){
          p.open = false;
        }
      })
      return;
    }
    if (!this.menuOpen) {
      this.appPages.map( p => {
        if(p.open && p.id !== page.id){
          p.open = false;
          this.submenuOpen = false;
        }
      })
      if(page.open && !this.submenuOpen){
        this.submenuOpen = true;
      } else {
        page.open = !page.open;
        this.submenuOpen = !this.submenuOpen;
      }
      this.activePage = page;
      if (page.open) this.showActions = false;
      else this.showActions = this.showActions;
    }
  }

  presentBottomModal(page: string) {
    if(!page){
      this.selectedSubMenu = null;
      return;
    }

    this.activePage = this.appPages.find(p => p.bottomTitle === page);
    //this.openBottomModal = !this.openBottomModal;
    this.bottomModal.present();
  }

  subMenuSelected(page: any) {
    this.selectedSubMenu = page;
    this.router.navigate([page.url])
    this.bottomModal.dismiss();
  }

}
